import { useCallback } from "react";
import useMenuStore from "stores/menuStore";
import { useMutationObservable } from "./useMutationObservable";

const useModalPaddingFix = () => {
  const { menuChangeMenuPadding } = useMenuStore();

  const onListMutation = useCallback(
    (mutationList) => {
      if (Array.isArray(mutationList)) {
        // eslint-disable-next-line array-callback-return
        mutationList.map((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "style"
          ) {
            menuChangeMenuPadding(
              mutation.target.style.paddingRight.indexOf("px") > -1
                ? parseInt(
                    mutation.target.style.paddingRight.replace("px", ""),
                    10
                  )
                : ""
            );
          }
        });
      }
    },
    [menuChangeMenuPadding]
  );
  useMutationObservable(document.body, onListMutation);

  return true;
};
export default useModalPaddingFix;
